<template>
  <div>
    <div class="common-header-wrap">
      <mt-header class="common-header" title="定位">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
      <div class="map-wrapper">
        <map-select ref="map_select" :ifShowCurrent="true" :latitude="lat" :longitude="lng"
                    @setPosition="setPosition"></map-select>
      </div>
    </div>
  </div>
</template>

<script>
import MapSelect from '../../../components/MapSelect'
import { mapMutations, mapState } from 'vuex'
import { getPosition } from '@src/util/map'

export default {
  name: 'HomeMap',
  data () {
    return {
      lng: 0,
      lat: 0
    }
  },
  components: {
    MapSelect
  },
  mounted () {
  },
  created: function () {
    getPosition((res) => {
      this.setLatitudeLongitude(res.coords.latitude, res.coords.longitude)
    }, (err) => {
    })
  },
  computed: {
    ...mapState({
      member_point: state => state.member.point
    })
  },
  methods: {
    ...mapMutations({
      memberPoint: 'memberPoint',
    }),
    getPosition,
    setLatitudeLongitude (lat, lng) {
      this.lat = lat
      this.lng = lng
    },
    setPosition (lat, lng, name) {
      let point = { address_longitude: lng, address_latitude: lat, address_detail: name}
      localStorage.setItem('guestAddress', JSON.stringify(point))
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.map-wrapper {
  position: absolute;
  top: 4rem;
  bottom: 2.5rem;
  width: 100%
}
</style>
